import { CancellationPolicyTable } from "@website/accommodation-ui/cancellation-policy-table";
import { CANCELLATION_RULES } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-cancellation/constant";
import { fetcher } from "@website/fetcher/fetcher";
import { useFetcher } from "@website/fetcher/use-fetcher/use-fetcher";
import { MaterialIcon } from "@website/icons/material";
import { today, tomorrow } from "@website/utils/date-format";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { memo } from "react";

interface Properties {
  hotelId: number;
  roomId: string | number | undefined;
  cancellation_policy: string;
}

const Component = ({ hotelId, roomId, cancellation_policy }: Properties) => {
  const router = useRouter();
  const hotelRules = cancellation_policy?.split?.(".") ?? [];

  const { data, isPending } = useFetcher({
    enabled: Boolean(roomId && hotelId),
    queryKey: [router.query.date_from, router.query.date_to, roomId, hotelId],
    queryFn: ({ queryKey: [date_from, date_to] }) => {
      const dateFrom = date_from || today();
      const dateTo = date_to || tomorrow();
      return fetcher({
        url: CANCELLATION_RULES({
          hotelId: toString(hotelId),
          roomId: toString(roomId),
          dateFrom: toString(dateFrom),
          dateTo: toString(dateTo)
        }),
        method: "GET"
      });
    }
  });

  if (!isPending)
    return (
      <div className="px-6 py-8 lg:px-8 lg:py-12">
        {data?.data?.length > 0 ? (
          <CancellationPolicyTable rules={data?.data} />
        ) : (
          hotelRules?.length > 0 && (
            <div className="text-body-2 text-on-surface-high-emphasis flex flex-col gap-2">
              {hotelRules.map((item) => {
                const html = numberConvert(item, {
                  locale: router.locale
                })
                  .replaceAll("&nbsp;", "")
                  .trimStart()
                  .replace("-", "");
                return (
                  <div
                    className="text-body-2 text-on-surface-high-emphasis flex flex-row items-start gap-1 pb-1"
                    hidden={!html}
                    key={html}
                  >
                    <div className="text-on-surface-medium-emphasis">
                      <MaterialIcon name="check" />
                    </div>
                    <span dangerouslySetInnerHTML={{ __html: `${html}.` }} />
                  </div>
                );
              })}
            </div>
          )
        )}
      </div>
    );
};
export const HotelReserveCardDetailCancellation = memo(Component, deepCompare);
